export default __webpack_public_path__ + "static/media/facebook.8d51a556.png";